import styled from "styled-components";

const StyledSupportFilter = styled.div`
  width: 100%;
`;

export default StyledSupportFilter;
